import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { LanguageSwitcher } from '@/components/ui/LanguageSwitcher';
import { LOGO_HEIGHT, LOGO_URL, LOGO_WIDTH } from '@/lib/brand';

function navLinkClassName({ isActive }: { isActive: boolean }): string {
  if (isActive) {
    return 'nav-link nav-link-active';
  }
  return 'nav-link';
}

/* Masthead: wordmark and section name on the left, small-caps navigation on the right,
   closed by a 2px ink rule and a hairline. */
export function Header() {
  const { t } = useTranslation('public');
  return (
    <header className="global-container">
      {/* Bottom-aligned row: the wordmark's bottom edge is the shared reference line. The serif
          title uses a line box equal to its font size and drops 0.17em, because Noto Serif SC
          ideographs sit that much above the box bottom; the nav keeps 24px line boxes. */}
      <div className="flex items-end justify-between gap-6 border-b-2 border-ink pb-3 pt-5 md:pb-4 md:pt-7">
        <NavLink to="/" className="flex items-end gap-3 md:gap-4" aria-label={`TOGAPhotos ${t('brand.calendar')}`}>
          <img
            src={LOGO_URL}
            width={LOGO_WIDTH}
            height={LOGO_HEIGHT}
            alt="TOGAPhotos"
            className="block h-5 w-auto select-none md:h-6"
          />
          <span className="hidden translate-y-[0.17em] font-serif text-xl leading-none tracking-[-0.01em] sm:block md:text-2xl md:leading-none" aria-hidden="true">
            {t('brand.calendar')}
          </span>
        </NavLink>

        <nav
          className="flex items-center gap-4 text-xs uppercase leading-6 tracking-[0.14em] md:gap-6"
          aria-label={t('nav.label')}
        >
          <NavLink to="/" end className={navLinkClassName}>
            {t('nav.home')}
          </NavLink>
          <NavLink to="/calendar" className={navLinkClassName}>
            {t('nav.calendar')}
          </NavLink>
          <LanguageSwitcher />
        </nav>
      </div>
      <div className="mt-0.5 h-px bg-rule" aria-hidden="true" />
    </header>
  );
}
